const generateTryoutRoutes = () => {
  const activeTryout = process.env.VUE_APP_ACTIVE_TRYOUT?.split(",") || [];

  return activeTryout.map((tryout) => ({
    path: `/tryout/${tryout}`,
    name: `tryout-${tryout}`,
    meta: {
      pageTitle: "Tryout",
      breadcrumb: [
        {
          text: `Tryout ${
            tryout === "tka" ? "TKA SMA/MA/SMK" : tryout.toUpperCase()
          }`,
          active: true,
        },
      ],
    },
    component: () => import("@/views/dashboard/manajemen-try-out/index.vue"),
  }));
};

export default [
  {
    path: "/monitoring-tryout",
    name: "monitoring-tryout",
    meta: {
      pageTitle: "Monitoring Tryout",
      requireAuth: true,
      breadcrumb: [{ text: "Monitoring Tryout", active: true }],
    },
    component: () => import("@/views/dashboard/monitoring-tryout/index.vue"),
  },
  {
    path: "/tryout/",
    name: "tryout",
    meta: {
      pageTitle: "Tryout",
      breadcrumb: [
        {
          text: "Tryout",
          active: true,
        },
      ],
    },
    component: () => import("@/views/dashboard/manajemen-try-out/index.vue"),
  },

  {
    path: "/tryout/:tipe/rank/:paket_tryout_id",
    name: "tryout-rank",
    meta: {
      pageTitle: "Ranking Tryout",
      requireAuth: true,
      breadcrumb: [
        {
          text: "Tryout",
          active: false,
        },
        {
          text: "Ranking",
          active: true,
        },
      ],
    },
    component: () =>
      import("@/views/dashboard/manajemen-try-out/rank/detail.vue"),
  },

  {
    path: "/tryout/:tipe/pengerjaan/:paket_tryout_id",
    name: "tryout-pengerjaan",
    meta: {
      pageTitle: "Semua Pengerjaan",
      requireAuth: true,
      breadcrumb: [
        {
          text: "Tryout",
          active: false,
        },
        {
          text: "Pengerjaan",
          active: true,
        },
      ],
    },
    component: () =>
      import("@/views/dashboard/manajemen-try-out/pengerjaan/index.vue"),
  },

  ...generateTryoutRoutes(),
];
